import React, { useState } from 'react';

const TermsAndConditions = () => {
    const [isAgreed, setIsAgreed] = useState(false);
    const sectionHeaderStyle = {
        borderBottom: '2px solid #F39C12',
        paddingBottom: '10px',
        marginTop: '20px',
        color: '#0D1B2A',
        fontWeight: 'bold'
    };

    const listItemStyle = {
        marginBottom: '12px',
        lineHeight: '1.6',
        color: '#34495E'
    };

    return (
        <div className="terms-container no-scrollbar" style={{ padding: '40px 20px', maxWidth: '900px', margin: 'auto', fontFamily: 'Arial, sans-serif' }}>
            <h1 style={{ color: '#F39C12', textAlign: 'center', marginBottom: '40px' }}>Professional Service Agreement</h1>

            <section style={{
                backgroundColor: '#FBFCFC',
                padding: '25px',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                // maxHeight: '500px', 
                // overflowY: 'auto',
                border: '1px solid #eee'
            }}>
                <h3 style={sectionHeaderStyle}>Code of Conduct for Civil Engineers</h3>
                <p style={{ marginTop: '15px' }}><i>By registering as a professional on the Docity platform, I solemnly affirm and agree to the following:</i></p>

                <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
                    <li style={listItemStyle}><strong>✅ Credentials & Authenticity:</strong> I certify that all educational certificates, university details, and professional licenses provided are original, authentic, and currently valid.</li>
                    <li style={listItemStyle}><strong>✅ Legal Compliance:</strong> I shall strictly abide by the state laws, building codes, and operational guidelines set forth by Docity management.</li>
                    <li style={listItemStyle}><strong>✅ Confidentiality & Data Privacy:</strong> I will maintain 100% confidentiality regarding customer data. I shall not download, share, or disclose customer correspondence, property documents, or personal submissions to any third party.</li>
                    <li style={listItemStyle}><strong>✅ Continuous Training:</strong> I agree to complete all mandatory training modules and certification updates as prescribed by Docity to maintain service quality.</li>
                    <li style={listItemStyle}><strong>✅ Conflict of Interest:</strong> I will not engage in any private dealings with Docity clients outside of the platform that could represent a conflict of interest or bypass platform protocols.</li>
                    <li style={listItemStyle}><strong>✅ Accuracy of Reports:</strong> I take full professional responsibility for the accuracy of property valuations, sale deed drafts, and technical assessments provided through my account.</li>
                    <li style={listItemStyle}><strong>✅ Communication Ethics:</strong> I will maintain a professional and respectful tone in all chat interactions and will not use the platform for any communication unrelated to property verification services.</li>
                    <li style={listItemStyle}><strong>✅ Account Security:</strong> I am solely responsible for maintaining the security of my login credentials and will immediately report any unauthorized access to Docity support.</li>
                    <li style={listItemStyle}><strong>✅ Timely Delivery:</strong> I commit to adhering to the SLA (Service Level Agreement) timelines for document review and response to ensure customer satisfaction.</li>
                </ul>
            </section>

            {/* Agreement Interaction Area */}
            <div style={{
                marginTop: '30px',
                padding: '20px',
                borderTop: '1px solid #eee',
                textAlign: 'center',
                backgroundColor: '#fff'
            }}>
                <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '16px' }}>
                    <input
                        type="checkbox"
                        checked={isAgreed}
                        onChange={(e) => setIsAgreed(e.target.checked)}
                        style={{ marginRight: '12px', width: '20px', height: '20px', accentColor: '#F39C12' }}
                    />
                    <span>I have read and agree to the Professional Code of Conduct</span>
                </label>

                {/* <button
                    onClick={handleAccept}
                    disabled={!isAgreed}
                    style={{
                        marginTop: '20px',
                        padding: '12px 40px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'white',
                        backgroundColor: isAgreed ? '#F39C12' : '#BDC3C7',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: isAgreed ? 'pointer' : 'not-allowed',
                        transition: 'background-color 0.3s ease'
                    }}
                >
                    Continue to Dashboard
                </button> */}
            </div>

            <footer style={{ marginTop: '30px', textAlign: 'center', fontSize: '13px', color: '#7F8C8D' }}>
                <p>Last Updated: December 2025 | Docity Management Reserve all Rights.</p>
            </footer>
        </div>
    );
};

export default TermsAndConditions;